import { createSlice } from "@reduxjs/toolkit";
import {
  clearTokensFromLocalStorage,
  getTokensFromLocalStorage,
  saveTokensToLocalStorage,
} from "../Utility/AccessAndRefreshTokenStorage";

// * Set authorization initial state
if (localStorage.getItem("Authorization") === null) {
  saveTokensToLocalStorage(null, null, false);
}
const { logIn } = getTokensFromLocalStorage();

export const UserLoginStatusSlice = createSlice({
  name: "UserLoginStatus",
  initialState: {
    login: logIn,
    profile_Info: null,
    refreshTokenIsValid: null,
  },
  reducers: {
    setUserLogin: (state) => {
      state.login = true;
    },
    setUserNewEmail: (state, action) => {
      if (state.login && state.profile_Info && state.profile_Info?.email) {
        state.profile_Info.email = action.payload;
      }
    },

    setUSerSingOut: (state) => {
      if (state.login === true) {
        state.login = false;
        state.refreshTokenIsValid = null;
        state.profile_Info = null;
        clearTokensFromLocalStorage();
      }
    },

    setUserProfileInfo: (state, action) => {
      if (state.login === true) {
        state.profile_Info = action.payload;
        state.refreshTokenIsValid = true;
      }
    },

    setRefreshTokenInValid: (state) => {
      state.login = false;
      state.refreshTokenIsValid = false;
      clearTokensFromLocalStorage();
    },
    setDefaultUserSate: (state) => {
      state.login = logIn;
      state.refreshTokenIsValid = null;
      state.profile_Info = null;
      clearTokensFromLocalStorage();
    },
    // * Reducers come here
  },
  extraReducers: (builder) => {
    // * Extra Reducers come here
  },
});

export const {
  setUserLogin,
  setUSerSingOut,
  setRefreshTokenInValid,
  setUserProfileInfo,
  setDefaultUserSate,
  setUserNewEmail,
} = UserLoginStatusSlice.actions;
export default UserLoginStatusSlice.reducer;
